// import {} from "../../utils/constant";

class HomeFinance {
  constructor(homeFinance,backdrop) {
    this.homeFinance = document.getElementById(homeFinance);
    this.SliderDownPayment = document.getElementById("SliderDownPayment");
    this.tenure = document.getElementById("tenure");
    this.backdrop = document.getElementById(backdrop);
    this.HMCalc = {
      DebtListRowId: 0,
      DebtListArray: [],
      startAge: 21,
      endAge: 70,
      startDownPayment: 15,
      endDownPayment: 100,
      rbNationalityType: "UAENationalSelfEmployed",
      rbSalaryTransfer: "rbSalaryTransferNo",
      SelectedAge: 21,
      MonthlyIncomeAmount: 0,
      PropertyPrice: 0,
      Affordability: 0,
      DownPayment: 0,
      FinanceYears: 25,
      TotalLiabilities: 0,
      allowedFinanceYears: 0,
      DownPaymentSelectedPercentage: 15,
      EIBOR: 5.75,
      Margin: 0,
      StressRate: 2,
      StressedDBR: 2,
      AffordabilityResult: 0,
      DBRResult: 0,
      MonthlyNormalEMI: 0,
      MonthlyNormalEMIForFixedtenor: 0,
      MonthlyDBREMI: 0,
      MonthlyAffordabilityEMI: 0,
      loanAmount: 0,
      profitRatePerMonth: 0,
      profitRatePerMonthwithStress: 0,
      MonthlyIncomeAmount: 1,
      profitRateForFixedTenor: 0,
      profitRateForFixedTenorPrice: 5,
      rbFixedTenorType: 3,
      UserProfitRate: 0,
      MonthlyNormalEMIWithStress: 0,
    };
    this.btnEnabled = true;
    this.init();
  }
  init() {
    if (this.homeFinance) {
      this.bindEvents();
      this.initAge(21, 70);
      let max = $(this.calculatormain).find("#percent_finance").attr('data-slider-max');
    }
  }

  bindEvents() {
    $("#rlbPropertyPrice").text($("#txtPropertyPrice").val() || 0);
    this.HMCalc.Affordability = parseInt($("#txtAffordability").val()) || 0;
    this.HMCalc.PropertyPrice = parseInt($("#txtPropertyPrice").val()) || 0;
    this.HMCalc.AffordabilityResult =
      (this.HMCalc.AffordabilityResult / this.HMCalc.MonthlyIncomeAmount) * 100;

    this.HMCalc.rbNationalityType = $(
      "input[name='rbNationalityType']:checked"
    ).val();
    this.HMCalc.rbSalaryTransfer = $(
      "input[name='rbSalaryTransfer']:checked"
    ).val();

    if ($("input[name='rbDebtType']:checked").val() != "credit_Card") {
      $("#lbl_pop_limit").text("Monthly Installment");
    } else {
      $("#lbl_pop_limit").text("Credit Limit");
    }

    $("input[name='rbNationalityType']").on("change", function () {
      if (
        $("input[name='rbNationalityType']:checked").val() ==
          "ExpatriateSalaried" ||
        $("input[name='rbNationalityType']:checked").val() ==
          "UAENationalSalaried"
      ) {
        $("#divTransferSalary").show();
      } else {
        $("#divTransferSalary").hide();
      }
    });

    $("#congrats-msg").hide();
    $("#danger-msg").hide();
    $("#danger-additional-msg").hide();

    if ($("input[name='rbDebtStatus']:checked").val() == "Yes") {
      $("#btnAddDebt").show();
    } else {
      $("#btnAddDebt").hide();
    }

    $("input[name='rbDebtStatus']").on("change", function () {
      if ($(this).val() == "Yes") {
        $("#btnAddDebt").show();
      } else {
        $("#btnAddDebt").hide();
      }
    });

    $("input[name='rbDebtType']").change(function () {
      if ($(this).is(":checked")) {
        var value = $(this).val();

        if (value != "credit_Card") {
          $("#lbl_pop_limit").text("Monthly Installment ");
        } else {
          $("#lbl_pop_limit").text("Credit Limit ");
        }
      }
    });

    

    const rbNationalityTypeInputs = document.querySelectorAll(
      "input[name='rbNationalityType']"
    );

    rbNationalityTypeInputs.forEach((input) => {
      input.addEventListener(
        "change",
        this.changeNationalityChange.bind(this,input)
      );
    });

    const rbSalaryTransferInputs = document.querySelectorAll(
      "input[name='rbSalaryTransfer']"
    );

    rbSalaryTransferInputs.forEach((input) => {
      input.addEventListener("change",
      this.SalaryTransferChange.bind(this,input)
      );
    });

    const rbFixedTenorTypeInputs = document.querySelectorAll(
      "input[name='rbFixedTenorrType']"
    );

    rbFixedTenorTypeInputs.forEach((input) => {
      input.addEventListener("change", 
      this.TenureTypeInputChange.bind(this,input)
      );
    });

    //   AGE
   
      var ddlAge = this.homeFinance.querySelector("#ddlAge");
      ddlAge &&  ddlAge.addEventListener(
        "change",
        this.AgeChange.bind(this,ddlAge)
      );


    //   USERPROFIT
  
      var txtProfitRate = this.homeFinance.querySelector("#txtProfitRate");
      txtProfitRate.addEventListener(
        "input",
        this.profitRateChange.bind(this,txtProfitRate)
      );
    //   MONTHLY INCOME

      var txtMonthlyIncome = this.homeFinance.querySelector("#txtMonthlyIncome");
      txtMonthlyIncome.addEventListener(
        "input",
        this.monthlyIncomeInputChange.bind(this)
      );

    $("#txtDebtAmount").on("input", function () {
      var sanitizedValue = $(this)
        .val()
        .replace(/[^0-9]/g, ""); // accept only number
      $(this).val(sanitizedValue);
    });

    //   PROPERTY PRICE
   
      var txtPropertyPrice = this.homeFinance.querySelector("#txtPropertyPrice");
      txtPropertyPrice && txtPropertyPrice.addEventListener("input",
      this.propertyPriceChange.bind(this)
      );


    //   Affordability
    const txtAffordability = this.homeFinance.querySelector("#txtAffordability");

    txtAffordability && txtAffordability.addEventListener("input", 
        this.txtAffordabilityChange.bind(this)
    );
  
    $("#addLiabilityBtnClose").on("click", () => {
      $("#alertModal").hide();
    });

    $("#btnAddToDebtList").on("click", 
    this.addButtonToDebtList.bind(this));

    var lsitDept=this.homeFinance.querySelectorAll(".remove-debt");
    lsitDept.forEach((item) =>{
      item.addEventListener("click",
      this.RemveDept.bind(this)
      )
    });

    //   Visibility of add laibility button
  
      var debtStatusInputs = this.homeFinance.querySelectorAll(
        "input[name='rbDebtStatus']"
      );
      debtStatusInputs.forEach((item) => {
        item.addEventListener("change", this.debtStatusInputsChange.bind(this, item));
      })
     

    //   this.liabilityModal
   
    $("#btnAddToDebtListClose").click(function () {
      $("#modal_add_liabilities").hide();
      $("body").removeClass("modal-open");
      $("body").css("overflow", "auto");
      $("#backdrop").css("display", "none");
    });

    var buttonDept= this.homeFinance.querySelector("#btnAddDebt");
    buttonDept.addEventListener("click",
    this.liabilityModal.bind(this)
    )
    
    
    $("#exp-div").hide();
    var nationalityType = document.querySelectorAll("input[name='nationalityType']");
    nationalityType.forEach(item=>(
      item.addEventListener("change",
      this.NationalityChangeInput.bind(this,item)))
    )
    const initialDownPayment = this.homeFinance?.getAttribute('data-rbUAENationalSalaried');
    this.updateSliderDownPayment(parseInt(initialDownPayment), 100);
    this.updateSliderFinanceYears(1, 25);
  }
  liabilityModal(event) {
    if( $('input[name="rbDebtStatus"]:checked').val()=="Yes")
    {
        $("#modal_add_liabilities").show();
        $("body").addClass("modal-open");
        $("body").css("overflow", "auto");
        $("#backdrop").css("display", "block");
        this.backdrop.classList.add("open");
        var modalElement = document.getElementById('modal_add_liabilities');
        var modal = new bootstrap.Modal(modalElement);
        modal.show();
    }
  }

  initAge(startAge, endAge) {
    this.HMCalc.startAge = startAge;
    this.HMCalc.endAge = endAge;
    var options =
      "<option value=" + startAge + " selected>" + startAge + "</option>";
    for (var index = startAge + 1; index < endAge; index++) {
      options += "<option value=" + index + ">" + index + "</option>";
    }
    $("#ddlAge").html(options);
  }

  updateSliderDownPayment(minRange, maxRange) {
    this.HMCalc.startDownPayment = minRange;
    this.HMCalc.endDownPayment = maxRange;
    this.HMCalc.DownPaymentSelectedPercentage = minRange;
    this.HMCalc.PropertyPrice = parseInt($("#txtPropertyPrice").val()) || 0;
    this.updateDownPaymentDetails(); //initialize
    let checkLang = document.querySelector("html").getAttribute('lang');
    $("#SliderDownPayment").slider({
      range: "min",
      value: minRange,
      min: minRange,
      max: maxRange,
      isRTL: checkLang === 'ar' ? true : false,
      step: 1,
      slide: (event, ui) => { 
        this.handleSlide(event,ui);
      },
    });
  }

  handleSlide(event, ui) {
    this.HMCalc.DownPaymentSelectedPercentage= ui.value;
    this.updateDownPaymentDetails();
}
updateDownPaymentDetails()  {
  //this.HMCalc.PropertyPrice = parseInt($("#txtPropertyPrice").val()) || 0;
  let getPropertyPrice = $("#txtPropertyPrice").val().toString().replace(/,/g, "") || 0;
  this.HMCalc.PropertyPrice = parseInt(getPropertyPrice, 10);
  
  $("#lbDownPaymentMinRange").text(this.HMCalc.startDownPayment + "%");
  $("#lbDownPaymentMaxRange").text(this.HMCalc.endDownPayment + "%");
  this.HMCalc.DownPayment = this.percentageCalc(
    this.HMCalc.DownPaymentSelectedPercentage,
    this.HMCalc.PropertyPrice
  );
  $("#txtDownPayment").val(this.numberWithCommas(this.HMCalc.DownPayment));
  $("#rlbDownPayments").text(this.numberWithCommas(this.HMCalc.DownPayment));
  $("#lbDownPaymentPercentage").text(
    this.HMCalc.DownPaymentSelectedPercentage + " %"
  );

  this.monthlyInstallmentCalculation();
};

percentageCalc(percentage, price) {
  var value = 0;
  value = (percentage / 100) * price;

  return value;
}
numberWithCommas(n) {
  var roundedValue = Math.round(n);
  return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

monthlyInstallmentCalculation () {
  this.HMCalc.profitRatePerMonth =
    (this.HMCalc.UserProfitRate + this.HMCalc.Margin) / 12 / 100;

  this.HMCalc.profitRatePerMonthwithStress =
    (this.HMCalc.UserProfitRate +
      this.HMCalc.Margin +
      this.HMCalc.StressRate) /
    12 /
    100;

  this.HMCalc.loanAmount = Math.round(
    this.HMCalc.PropertyPrice - this.HMCalc.DownPayment
  );
  $("#rlbFinanceValue").text(this.numberWithCommas(this.HMCalc.loanAmount));

  var FinanceYearsInMonth = this.HMCalc.FinanceYears * 12;

  this.HMCalc.MonthlyNormalEMI = Math.round(
    Math.abs(
      this.pmt(
        this.HMCalc.profitRatePerMonth,
        FinanceYearsInMonth,
        this.HMCalc.loanAmount
      )
    )
  );

  this.HMCalc.MonthlyNormalEMIWithStress = Math.round(
    Math.abs(
      this.pmt(
        this.HMCalc.profitRatePerMonthwithStress,
        FinanceYearsInMonth,
        this.HMCalc.loanAmount
      )
    )
  );

  $("#rlbMonthlyInstallment").text(
    this.numberWithCommas(this.HMCalc.MonthlyNormalEMI)
  );
  $("#rlbMonthlyInstallmentWithStress").text(
    this.numberWithCommas(this.HMCalc.MonthlyNormalEMIWithStress)
  );
  let txtAffordability = $("#txtAffordability").val().toString().replace(/,/g, "") || 0;
  this.HMCalc.Affordability = parseInt(txtAffordability, 10);
  

  console.log(this.HMCalc.Affordability)
  this.HMCalc.AffordabilityResult =
    this.HMCalc.Affordability +
    this.HMCalc.TotalLiabilities +
    this.HMCalc.MonthlyNormalEMI;
  this.HMCalc.AffordabilityResult =
    (this.HMCalc.AffordabilityResult / this.HMCalc.MonthlyIncomeAmount) *
    100;

  var clampedValue = Math.min(
    100,
    Math.max(1, this.HMCalc.AffordabilityResult)
  );
  var OverallCaseDecision = 100 - clampedValue;

  $(".bar").css("left", OverallCaseDecision + "%");

  if (OverallCaseDecision <= 0) {
    $("#congrats-msg").hide();
    $("#danger-msg").show();
    $("#danger-additional-msg").show();
  } else {
    $("#congrats-msg").show();
    $("#danger-msg").hide();
    $("#danger-additional-msg").hide();
  }

  if (this.HMCalc.MonthlyNormalEMI <= 0) {
    $("#congrats-msg").hide();
    $("#danger-msg").hide();
    $("#danger-additional-msg").hide();
  }
};

pmt(
  rate_per_period,
  number_of_payments,
  present_value,
  future_value,
  type
) {
  future_value = typeof future_value !== "undefined" ? future_value : 0;
  type = typeof type !== "undefined" ? type : 0;

  if (rate_per_period != 0.0) {
    var q = Math.pow(1 + rate_per_period, number_of_payments);
    return (
      -(rate_per_period * (future_value + q * present_value)) /
      ((-1 + q) * (1 + rate_per_period * type))
    );
  } else if (number_of_payments != 0.0) {
    return -(future_value + present_value) / number_of_payments;
  }

  return 0;
};
changeNationalityChange (target,event) {
  if (target.checked) {
    const value = target.value;

    this.HMCalc.rbNationalityType = value;

    if (this.HMCalc.rbNationalityType === "UAENationalSalaried") {
      this.initAge(21, 70);
    } else if (
      this.HMCalc.rbNationalityType === "UAENationalSelfEmployed" ||
      this.HMCalc.rbNationalityType === "ExpatriateSelfEmployed"
    ) {
      this.initAge(30, 70);
    } else if (this.HMCalc.rbNationalityType === "ExpatriateSalaried") {
      this.initAge(21, 65);
    } else if (this.HMCalc.rbNationalityType === "NonResident") {
      this.initAge(25, 65);
    }

    if (
      this.HMCalc.rbNationalityType === "ExpatriateSalaried" ||
      this.HMCalc.rbNationalityType === "UAENationalSalaried"
    ) {
      document.getElementById("divTransferSalary").style.display =
        "block";
    } else {
      document.getElementById("divTransferSalary").style.display =
        "none";
      document.getElementById("rbSalaryTransferNo").checked = true;
    }

    // update down payment rules
    this.HMCalc.PropertyPrice =
      parseInt(document.getElementById("txtPropertyPrice").value) || 0;

    //UAE nationals
    if (
      this.HMCalc.rbNationalityType === "UAENationalSalaried" ||
      this.HMCalc.rbNationalityType === "UAENationalSelfEmployed"
    ) {
      //15% for uae nationals for less than 5M
      let nationalDownPayment = 0;
      if(this.HMCalc.rbNationalityType === "UAENationalSalaried"){
        nationalDownPayment = this.homeFinance?.getAttribute('data-rbUAENationalSalaried');
      }       
      if(this.HMCalc.rbNationalityType === "UAENationalSelfEmployed"){
        nationalDownPayment = this.homeFinance?.getAttribute('data-rbUAENationalSelfEmployed');
      }        
      if(nationalDownPayment){
        this.updateSliderDownPayment(parseInt(nationalDownPayment), 100);
      }
      else if (this.HMCalc.PropertyPrice <= 5000000) {
        this.updateSliderDownPayment(15, 100);
      } else {
        this.updateSliderDownPayment(25, 100);
      }
    }

    //Expat
    else if (
      this.HMCalc.rbNationalityType === "ExpatriateSalaried" ||
      this.HMCalc.rbNationalityType === "ExpatriateSelfEmployed"
    ) {
      //15% for uae nationals for less than 5M
      let expatriateDownPayment = 0;
      if(this.HMCalc.rbNationalityType === "ExpatriateSalaried"){
        expatriateDownPayment = this.homeFinance?.getAttribute('data-rbExpatriateSalaried');
      }  
      if(this.HMCalc.rbNationalityType === "ExpatriateSelfEmployed") {
        expatriateDownPayment = this.homeFinance?.getAttribute('data-rbExpatriateSelfEmployed');
      }
      if(expatriateDownPayment){
        this.updateSliderDownPayment(parseInt(expatriateDownPayment), 100);
      }
      else if (this.HMCalc.PropertyPrice <= 5000000) {
        this.updateSliderDownPayment(20, 100);
      } else {
        this.updateSliderDownPayment(30, 100);
      }
    }

    else if (this.HMCalc.rbNationalityType === "NonResident") {
      const residentDownPayment = this.homeFinance?.getAttribute('data-rbNonResident');
      this.updateSliderDownPayment(parseInt(residentDownPayment), 100);
    }
  }
  this.updateDownPaymentDetails();
}

SalaryTransferChange (target,event) {
  if (target.checked) {
    const value = target.value;
    this.HMCalc.rbSalaryTransfer = value;
  }
  this.updateDownPaymentDetails();
}

TenureTypeInputChange (target,event) {
  if (target.checked) {
    const value = target.value;
    this.HMCalc.rbFixedTenorType = parseInt(value);
  }
  this.updateDownPaymentDetails();
}

AgeChange (el, item) {
  this.HMCalc.SelectedAge = parseInt(el.value);
  this.HMCalc.allowedFinanceYears =
    this.HMCalc.endAge - this.HMCalc.SelectedAge;
  if (this.HMCalc.allowedFinanceYears < 25) {
    this.updateSliderFinanceYears(1, this.HMCalc.allowedFinanceYears);
    this.HMCalc.FinanceYears = this.HMCalc.allowedFinanceYears;
  } else {
    this.updateSliderFinanceYears(1, 25);
    this.HMCalc.FinanceYears = 25;
  }
  this.updateDownPaymentDetails();
}

userProfitChange (target,event) {
  var sanitizedValue = target.value.replace(/[^0-9.]/g, ""); // accept only number
  target.value = sanitizedValue;
  this.HMCalc.UserProfitRate = parseFloat(sanitizedValue) || 0; // use parseFloat to handle decimal numbers

  var lbErrorProfitRate = document.getElementById("lbErrorProfitRate");
  if (this.HMCalc.UserProfitRate == 0) {
    lbErrorProfitRate.textContent =
    this.homeFinance?.getAttribute('data-profit-rate');
  } else {
    lbErrorProfitRate.textContent = "";
  }

  this.updateDownPaymentDetails();
}


  profitRateChange (target,event) {
    var sanitizedValue = target.value.replace(/[^0-9.]/g, ""); // accept only number
    target.value = sanitizedValue;
    this.HMCalc.UserProfitRate = parseFloat(sanitizedValue) || 0; // use parseFloat to handle decimal numbers

    var lbErrorProfitRate = document.getElementById("lbErrorProfitRate");
    if (this.HMCalc.UserProfitRate == 0) {
      lbErrorProfitRate.textContent =
      this.homeFinance?.getAttribute('data-profit-rate');
    } else {
      lbErrorProfitRate.textContent = "";
    }

    this.updateDownPaymentDetails();
  }

  monthlyIncomeInputChange (event) {
    var sanitizedValue = event.target.value.replace(/[^0-9]/g, ""); // accept only number
    event.target.value = sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    this.HMCalc.MonthlyIncomeAmount = parseInt(sanitizedValue) || 0;

    var rbNationalityType = document.querySelector(
      "input[name='rbNationalityType']:checked"
    );
    this.HMCalc.rbNationalityType = rbNationalityType
      ? rbNationalityType.value
      : null;

    var rbSalaryTransfer = document.querySelector(
      "input[name='rbSalaryTransfer']:checked"
    );
    this.HMCalc.rbSalaryTransfer = rbSalaryTransfer
      ? rbSalaryTransfer.value
      : null;

    var lbErrorMonthlyIncome = document.getElementById(
      "lbErrorMonthlyIncome"
    );

    if (
      this.HMCalc.MonthlyIncomeAmount < 10000 &&
      (this.HMCalc.rbNationalityType == "UAENationalSalaried" ||
        this.HMCalc.rbNationalityType == "ExpatriateSalaried") &&
      this.HMCalc.rbSalaryTransfer == "Yes"
    ) {
      lbErrorMonthlyIncome.textContent =
      this.homeFinance?.getAttribute('data-monthlyincome-10000');
    } else if (
      this.HMCalc.MonthlyIncomeAmount < 15000 &&
      (this.HMCalc.rbNationalityType == "UAENationalSalaried" ||
        this.HMCalc.rbNationalityType == "ExpatriateSalaried") &&
      this.HMCalc.rbSalaryTransfer == "No"
    ) {
      lbErrorMonthlyIncome.textContent =
      this.homeFinance?.getAttribute('data-monthlyincome-15000');
    } else if (
      this.HMCalc.MonthlyIncomeAmount < 3000000 &&
      (this.HMCalc.rbNationalityType == "UAENationalSelfEmployed" ||
        this.HMCalc.rbNationalityType == "ExpatriateSelfEmployed")
    ) {
      lbErrorMonthlyIncome.textContent =
      this.homeFinance?.getAttribute('data-monthlyincome-3000000');
    } else if (
      this.HMCalc.MonthlyIncomeAmount < 15000 &&
      this.HMCalc.rbNationalityType == "NonResident"
    ) {
      lbErrorMonthlyIncome.textContent =
      this.homeFinance?.getAttribute('data-monthlyincome-nonresident-15000');
    } else {
      lbErrorMonthlyIncome.textContent = "";
    }
    this.updateDownPaymentDetails();
  }

  propertyPriceChange(event){
    var sanitizedValue = event.target.value.replace(/[^0-9]/g, ""); // accept only number
    event.target.value = sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.HMCalc.PropertyPrice = parseInt(sanitizedValue);
    var rlbPropertyPrice = document.getElementById("rlbPropertyPrice");
    rlbPropertyPrice.textContent = this.numberWithCommas(sanitizedValue);

    if (
      this.HMCalc.rbNationalityType == "UAENationalSalaried" ||
      this.HMCalc.rbNationalityType == "UAENationalSelfEmployed"
    ) {
      //15% for uae nationals for less than 5M
      if (this.HMCalc.PropertyPrice <= 5000000) {
        this.updateSliderDownPayment(15, 100);
      } else {
        this.updateSliderDownPayment(25, 100);
      }
    } else if (
      this.HMCalc.rbNationalityType == "ExpatriateSalaried" ||
      this.HMCalc.rbNationalityType == "ExpatriateSelfEmployed"
    ) {
      //15% for uae nationals for less than 5M
      if (this.HMCalc.PropertyPrice <= 5000000) {
        this.updateSliderDownPayment(20, 100);
      } else {
        this.updateSliderDownPayment(30, 100);
      }
    }

    this.updateDownPaymentDetails();
  }

  txtAffordabilityChange () {
    const sanitizedValue = txtAffordability.value.replace(/[^0-9]/g, ""); // accept only number
    txtAffordability.value = sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.HMCalc.Affordability = parseInt(sanitizedValue);
    this.updateDownPaymentDetails();
  }

  addButtonToDebtList()
  {
    var str = "";

    var selectedDebtType = $('input[name="rbDebtType"]:checked').val();
    var selectedDataLabel = $('input[name="rbDebtType"]:checked').data(
      "label"
    );
    var DebtAmount = parseInt($("#txtDebtAmount").val()) || 0;

    if (DebtAmount == "" || DebtAmount == "0") {
      // alert("Please Enter Debt Amount");
      $("#alertModal").modal("show");
    } else {
      /// add a row
      if (this.HMCalc && this.HMCalc.DebtListArray) {
        this.HMCalc.DebtListArray.push({
          id: this.HMCalc.DebtListRowId,
          DebtType: selectedDebtType,
          DebtTypeText: selectedDataLabel,
          DebtAmount: DebtAmount,
        });
      }

      str +=
        "<li  class='badge debt-li' id='" +
        this.HMCalc.DebtListRowId +
        "'><div class='debt-title'>" +
        selectedDataLabel +
        "</div><div class='debt-amt' >AED " +
        this.numberWithCommas(DebtAmount) +
        "</div><a class='btn-transparent remove-debt debt-remove' data-debt-type='personal_loan'></a></li>";

      $("#ulDebitList").append(str);
      str = "";
      ++this.HMCalc.DebtListRowId;
      $("#txtDebtAmount").val("");
      this.calculateSumOfLiabilities();
    }
    this.updateDownPaymentDetails();
    var lsitDept=this.homeFinance.querySelectorAll(".remove-debt");
    lsitDept.forEach((item) =>{
      item.addEventListener("click",
      this.RemveDept.bind(this)
      )
    });
  }

  RemveDept (e) {
    // e.preventDefault();
    // var removedLiId = $(e.target).closest("li").attr("id");
    var removedLi = $(e.target).closest("li");
    var removedLiId = removedLi.attr("id");
    
    this.HMCalc.DebtListArray = this.HMCalc.DebtListArray.filter(function (
      item
    ) {
      return item.id != removedLiId;
    });
    // Find the closest <li> ancestor and remove it
    removedLi.remove();
    this.calculateSumOfLiabilities();
    this.updateDownPaymentDetails();
}

debtStatusInputsChange (event, target) {
  if (target.checked) {
    var value = target.value;
    if (value === "Yes") {
      document
        .querySelectorAll(".debtControls")
        .forEach(function (element) {
          element.style.display = "block";
        });
    } else {
      HMCalc.TotalLiabilities = 0;
      HMCalc.DebtListArray = [];
      document
        .querySelectorAll(".debtControls")
        .forEach(function (element) {
          element.style.display = "none";
        });
      document.getElementById("ulDebitList").innerHTML = "";
      document.getElementById("lblTotalLiabilities").textContent =
        HMCalc.TotalLiabilities;
    }
  }
  this.updateDownPaymentDetails();
}
calculateSumOfLiabilities ()  {
  if (this.HMCalc.DebtListArray.length == 0) {
    this.HMCalc.TotalLiabilities = 0;
    $("#lblTotalLiabilities").text(this.HMCalc.TotalLiabilities);
  }
  return this.HMCalc.DebtListArray.reduce((sum, item) => {
    var debtAmount = parseFloat(item.DebtAmount);
    if (!isNaN(debtAmount)) {
      if (item.DebtType == "credit_Card") {
        // Add only 5% for credit-card
        sum += 0.05 * debtAmount;
      } else {
        // Add the full amount for other types
        sum += debtAmount;
      }
    }
    this.HMCalc.TotalLiabilities = sum;
    $("#lblTotalLiabilities").text(
      this.numberWithCommas(this.HMCalc.TotalLiabilities)
    );

    return sum;
  }, 0);
}


updateSliderFinanceYears(minRange, maxRange){
  $("#lbFinanceYearsMinRange").text(minRange);
  $("#lbFinanceYearsMaxRange").text(maxRange);
  $("#input_tenure").val(maxRange);

  $("#rlbFinanceYears").text(maxRange);
  let checkLang = document.querySelector("html").getAttribute('lang');
  $("#tenure").slider({
    range: "min",
    value: maxRange,
    min: minRange,
    max: maxRange,
    step: 1,
    isRTL: checkLang === 'ar' ? true : false,
    slide:(event, ui)=>{
     this.handleFinanceYearSlide(event,ui);
    },
  });
}

handleFinanceYearSlide(event, ui) {
  $("#txtFinanceYears").val(this.numberWithCommas(ui.value));
  this.HMCalc.FinanceYears=parseInt(ui.value);
  $("#rlbFinanceYears").text(ui.value);
  $("#input_tenure").val(ui.value);
  this.updateDownPaymentDetails();
}

NationalityChangeInput (target) {
  if (target.value === "expatriate") {
    $("#exp-div").show();
  } else {
    $("#exp-div").hide();
  }

  this.initAge(21, 70);
}

}

export default HomeFinance;
